import { ApiPropertyOptional } from '@nestjs/swagger'
import { IsOptional, IsUUID, IsEnum, IsArray } from 'class-validator'
import { Type, Transform } from 'class-transformer'
import { OffsetPaginationQueryDto } from '@sphere/shared/domain'
import { PedagogicContentState } from '../../../enums/content.enum'

/**
 * DTO pour filtrer les leçons avec pagination offset
 */
export class ListLessonsQueryDto extends OffsetPaginationQueryDto {
  @ApiPropertyOptional({
    description: 'Filtrer par ID de chapitre',
    type: 'string',
  })
  @IsOptional()
  @IsUUID('4')
  chapterId?: string

  @ApiPropertyOptional({
    description:
      "Filtrer par ID de leçon : retourne les leçons du même chapitre que cette leçon (pour recherche contextuelle)",
    type: 'string',
  })
  @IsOptional()
  @IsUUID('4')
  lessonId?: string

  @ApiPropertyOptional({
    description: "Filtrer par ID d'enseignement",
    type: 'string',
  })
  @IsOptional()
  @IsUUID('4')
  teachingId?: string

  @ApiPropertyOptional({
    description: 'Filtrer par ID de statut',
    type: 'string',
  })
  @IsOptional()
  @IsUUID('4')
  statusId?: string

  @ApiPropertyOptional({
    description: 'Filtrer par ID de type de leçon',
    type: 'string',
  })
  @IsOptional()
  @IsUUID('4')
  typeId?: string

  @ApiPropertyOptional({
    description: 'Filtrer par ID du créateur',
    type: 'string',
  })
  @IsOptional()
  @IsUUID('4')
  ownerUserId?: string

  @ApiPropertyOptional({
    description: 'États à inclure dans les résultats (DRAFT, ACTIVE, ARCHIVED)',
    enum: PedagogicContentState,
    isArray: true,
    example: ['ACTIVE', 'ARCHIVED'],
  })
  @IsOptional()
  @Transform(({ value }: { value: string | string[] }) => (Array.isArray(value) ? value : [value]))
  @IsArray()
  @IsEnum(PedagogicContentState, { each: true })
  @Type(() => String)
  includeStates?: PedagogicContentState[]
}
